<div
  [ngSwitch]="viewportStatus !== ViewportStatus.OUTSIDE"
  [style.minHeight.px]="cachedHeight"
  class="c-virtualiser"
>
  <div *ngSwitchCase="true" #renderedRealChild class="c-virtualiser-real">
    <ng-container
      [ngTemplateOutlet]="childComponentTemplate"
      [ngTemplateOutletContext]="{ onDimensionChange: onDimensionChange }"
    >
    </ng-container>
  </div>

  <div
    *ngSwitchDefault
    [style.height.px]="cachedHeight"
    class="c-virtualiser-placeholder"
  >
    <ng-container [ngTemplateOutlet]="placeholderComponentTemplate">
    </ng-container>
  </div>
</div>
